<template>
  <div class="retention-analysis-main-container" v-loading="loading.initLoading">
    <div class="header">
      <div class="left">
        <span class="back" v-if="!!formComponent.boardId" @click="handleBack">
          <icon name="chevron-left" />
        </span>
        <!--<div class="tit">{{ headTitle }}</div>-->
        <t-breadcrumb style="margin-right: 20px">
          <t-breadcrumb-item>{{ headTitle }}</t-breadcrumb-item>
        </t-breadcrumb>
        <div class="mdRemod">
          <img :src="bookHref" style="margin-right: 5px" alt="" />
          <a href="https://docs.qq.com/doc/DS3pWb1dVZ1NjQmpF" target="_blank">说明文档</a>
        </div>
        <!--<new-guide-trigger class="new-guide-trigger" @click="handleStartGuide"></new-guide-trigger>-->
      </div>
      <div class="right">
        <t-button variant="outline" @click="handleOpenSave">
          <icon name="save" slot="icon" />
          保存
        </t-button>
      </div>
    </div>

    <my-card v-loading="loading.fetchFormOption">
      <div slot="header" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析条件</div>
        </div>
        <div class="right">
          <t-switch size="small" v-model="showAnalysisConditions"></t-switch>
          <span style="margin-left: 10px">{{ showAnalysisConditions ? '展开' : '收起' }}</span>
        </div>
      </div>

      <div class="form" v-show="showAnalysisConditions">
        <form-item
          class="row-item new-guide-step-1"
          label="关联属性"
          tips="关联属性使用在将起始行为和后续行为通过相同的属性值关联在一起的场景，如活动名称、商品名称等。需要打开关联属性后，关联属性必填且属性值类型须保持一致。"
        >
          <div style="margin-top: 8px">
            <t-switch size="small" v-model="analysisDataShowInfo.isLinkAttr"></t-switch>
            <span style="margin-left: 10px">{{ analysisDataShowInfo.isLinkAttr ? '已开启' : '未开启' }}</span>
          </div>
        </form-item>

        <retention-event
          v-model="formValue.retentionEventDTOS"
          :isLinkAttr="analysisDataShowInfo.isLinkAttr"
          :eventList="formOption.eventList"
          :conditionPropertyOptions="formOption.conditionPropertyOptions"
          :conditionOperatorOptions="formOption.conditionOperatorOptions"
        />

        <form-item label="全局筛选">
          <div class="global-filter-cont">
            <global-filter-item
              v-model="formValue.globalFilters.globalFilterList[index]"
              v-for="(item, index) in formValue.globalFilters.globalFilterList"
              :key="index"
              :index="index"
              :conditionPropertyOptions="formOption.conditionPropertyOptions"
              :conditionOperatorOptions="formOption.conditionOperatorOptions"
              :show-delete="formValue.globalFilters.globalFilterList.length > 1"
              @delete="handleDeleteConditionModels(index)"
            />
            <t-button @click="handleAddGlobalFilter" class="btn-filter" variant="outline">
              <icon name="add" slot="icon"></icon>
              新增对照组
            </t-button>
          </div>
        </form-item>

        <form-item class="row-item" label="分组展示维度">
          <div style="display: flex">
            <t-select
              v-model="analysisDataShowInfo.groupPropertyType"
              @change="onPropertyTypeChange"
              placeholder="请选择"
              style="width: 120px"
            >
              <t-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in formOption.groupPropertyTypeOptions"
                :key="index"
              ></t-option>
            </t-select>

            <event-and-property-selector
              v-if="analysisDataShowInfo.groupPropertyType !== -1"
              v-model="analysisDataShowInfo.groupEventAndProp"
              :all-event-property="formOption.allEventProperty"
              :filter-events="allFirstEvent"
              :filter-property-type="analysisDataShowInfo.groupPropertyType"
              :formatOptionLabelFunc="getGroupOptionLabelFormat"
              :format-option-value-func="getGroupOptionValueFormat"
              :placeholder="groupEventPropPlaceholder"
              style="margin-left: 10px"
              class="event-and-property-selector"
              @change="handleGroupEventAndPropChange"
            ></event-and-property-selector>
          </div>
        </form-item>

        <form-item class="row-item" :label="'也计算当' + formOption.timeUnitEnum[this.formValue.timeUnit] + '留存'">
          <t-radio-group v-model="formValue.isCalcToday">
            <t-radio :value="item.value" v-for="(item, index) in formOption.isCalcTodayOptions" :key="index">
              {{ item.label }}
            </t-radio>
          </t-radio-group>
        </form-item>

        <div style="margin-top: 20px">
          <t-button :loading="loading.fetchData" @click="handleQueryClick" style="font-size: 12px; width: 80px">
            查询
          </t-button>
          <t-button variant="outline" @click="handleReset" style="font-size: 12px; width: 80px">重置</t-button>
        </div>
      </div>
    </my-card>

    <my-card class="section-chart">
      <div slot="header" class="title">留存分析图表</div>
      <div class="operation-cont">
        <div class="operation-left">
          <t-select
            v-model="formValue.timeUnit"
            placeholder="请选择"
            class="operation-item"
            @change="handleChangeTimeUnit"
          >
            <t-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in formOption.timeUnitOptions"
              :key="index"
            ></t-option>
          </t-select>
          <t-date-picker
            mode="date"
            range
            v-model="analysisDataShowInfo.date"
            :disableDate="formOption.datePickerOptions.disabledDate"
            class="operation-item"
            @change="handleChangeDate"
          />
          <t-divider layout="vertical" style="height: 32px" />
          <template v-if="formValue.timeUnit === 'day'">
            <t-input-number
              theme="column"
              :decimalPlaces="0"
              :min="2"
              :max="120"
              v-model.number="formValue.followStartDay"
              class="operation-item"
              @change="handleChangeFollowStartDay"
            />
            <span class="operation-label">至</span>
            <t-tooltip content="目前支持最大间隔为30天" trigger="focus">
              <t-input-number
                theme="column"
                :decimalPlaces="0"
                :min="formValue.followStartDay + 1"
                :max="formValue.followStartDay + 30"
                v-model.number="formValue.followEndDay"
                class="operation-item"
                @change="handleChangeFollowEndDay"
              />
            </t-tooltip>
            <span class="operation-label" style="margin-right: 20px">天</span>
          </template>
          <t-select
            v-model="formValue.isRetention"
            placeholder="请选择"
            class="operation-item"
            @change="handleChangeIsRetention"
          >
            <t-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in formOption.isRetentionOptions"
              :key="index"
            ></t-option>
          </t-select>
        </div>
        <div class="operation-right">
          <div class="operation-label">展现形式</div>
          <t-select
            v-model="formValue.chartShowType"
            placeholder="请选择"
            class="operation-item"
            @change="handleChangeChartShowType"
          >
            <t-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in formOption.chartShowTypeOptions"
              :key="index"
            ></t-option>
          </t-select>
          <template>
            <div class="operation-label" style="margin-left: 12px">日期</div>
            <t-select
              v-model="formValue.chartShowDate"
              placeholder="请选择"
              class="operation-item"
              :options="chartShowDateOptions"
            />
          </template>
        </div>
      </div>
      <div class="retention-data-chart-cont" v-if="analysisData">
        <retention-data-chart
          :analysis-data="analysisData"
          :time-unit="formValue.timeUnit"
          :is-calc-today="formValue.isCalcToday"
          :follow-start-day="formValue.followStartDay"
          :follow-end-day="formValue.followEndDay"
          :chart-show-type="formValue.chartShowType"
          :chart-show-date="formValue.chartShowDate"
        />
      </div>
      <noData v-else />
    </my-card>

    <my-card class="section-table">
      <div slot="header" class="title">
        <div class="title-left">数据详情</div>
        <div class="title-right">
          <icon style="width: 16px; height: 16px; margin-right: 10px" name="download" @click="exportData"></icon>
        </div>
      </div>
      <retention-data-table
        :analysis-data="analysisData"
        v-if="analysisData"
        :time-unit="formValue.timeUnit"
        :is-calc-today="formValue.isCalcToday"
        :follow-start-day="formValue.followStartDay"
        :follow-end-day="formValue.followEndDay"
      />
      <noData v-else />
    </my-card>

    <save-action
      v-if="showBookmarkModal"
      :loading="loading.submitting"
      :board-info="boardInfo"
      :form-data-component="formComponent"
      :form-data-bookmark="formBookmark"
      @onClose="showBookmarkModal = false"
      @onSaveBookmark="handleSaveBookmark"
      @onSaveComponent="handleSaveComponent"
    ></save-action>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import lodash, { pick } from 'lodash';
import XLSX from 'xlsx';
import numeral from 'numeral';
import FormItem from './components/form-item.vue';
import DateRangePicker from '@/components/analysis/date-range-picker.vue';
import noData from '@/components/common/no-data-card.vue';
import SaveAction from './components/save.vue';
import bookHref from '@/assets/images/booklistHref.png';
import {
  getAllProperty,
  getEventList,
  getConditionOperator,
  saveAsBookmark,
  getBookmarkDetail,
  getAllEventProperty,
  getRetentionPollingId,
  getRetentionPollingData,
} from '@/api/analysis/custom-analysis';
import { createComponent, getBoardDetail, getComponentList, modifyComponent } from '@/api/analysis/custom-overview';

import { PollingAction } from '@/utils/helper';
import mixinGuide from '@/minxins/new-guide';
import TargetEvent from '@/views/analysis/user-path-analysis/components/target-event.vue';
import InterestEvent from '@/views/analysis/user-path-analysis/components/interest-event.vue';
import SankeyChart from '@/views/analysis/user-path-analysis/components/sankey-chart.vue';
import RetentionEvent from '@/views/analysis/retention-analysis/components/retention-event.vue';
import GlobalFilterItem from '@/views/analysis/retention-analysis/components/global-filter-item.vue';
import RetentionDataChart from '@/views/analysis/retention-analysis/components/retention-data-chart.vue';
import RetentionDataTable from '@/views/analysis/retention-analysis/components/retention-data-table.vue';
import EventAndPropertySelector from '@/components/analysis/event-and-property-selector.vue';
import {
  DEFAULT_CHART_SHOW_TYPE_OPTIONS,
  DEFAULT_DATE,
  DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS,
  DEFAULT_IS_CALC_TODAY_OPTIONS,
  DEFAULT_IS_RETENTION_OPTIONS,
  DEFAULT_TIME_UNIT_ENUM,
  DEFAULT_TIME_UNIT_OPTIONS,
} from '@/views/analysis/retention-analysis/components/config';

export default {
  name: 'RetentionAnalysis',
  mixins: [mixinGuide],
  components: {
    EventAndPropertySelector,
    RetentionDataTable,
    RetentionDataChart,
    GlobalFilterItem,
    RetentionEvent,
    SankeyChart,
    InterestEvent,
    TargetEvent,
    FormItem,
    noData,
    DateRangePicker,
    SaveAction,
  },
  data() {
    return {
      showAnalysisConditions: true,

      bookHref,
      loading: {
        initLoading: false,
        query: false,
        submitting: false,
        fetchData: false,
        fetchBookmark: false,
        fetchFormOption: false,
      },

      refreshCount: 0,
      showBookmarkModal: false,
      polling: null, //  轮询查询对象

      //  表单选项
      formOption: {
        eventList: [],
        conditionOperatorOptions: [
          // { type: 'eq', desc: '等于', javaType: 'string', canMore: 2 },
        ],
        conditionPropertyOptions: [],

        allEventProperty: [],

        datePickerOptions: {
          disabledDate: {
            after: dayjs().format(),
          },
        },

        isCalcTodayOptions: DEFAULT_IS_CALC_TODAY_OPTIONS,
        timeUnitOptions: DEFAULT_TIME_UNIT_OPTIONS,
        isRetentionOptions: DEFAULT_IS_RETENTION_OPTIONS,
        chartShowTypeOptions: DEFAULT_CHART_SHOW_TYPE_OPTIONS,
        groupPropertyTypeOptions: DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS,

        timeUnitEnum: DEFAULT_TIME_UNIT_ENUM,
      },

      formValue: {
        id: undefined,

        retentionEventDTOS: [
          {
            showLabel: '',
            firstEvent: {
              eventName: '',
              eventChineseName: '',
              relationDTO: {
                column: '',
                chineseName: '',
              },
              connectors: 'and',
              conditionModels: [],
              groupBy: '',
            },
            followEvent: {
              eventName: '',
              eventChineseName: '',
              relationDTO: {
                column: '',
                chineseName: '',
              },
              connectors: 'and',
              conditionModels: [],
            },
          },
        ],

        globalFilters: {
          globalFilterList: [
            {
              globalFilterIndex: 1,
              globalFilterName: '全体用户',
              conditionModels: [],
              connectors: 'and',
            },
          ],
        },

        timeUnit: 'day',
        isCalcToday: 0,
        isRetention: 1,
        followStartDay: 2,
        followEndDay: 7,
        chartShowType: 1, // 1： 趋势，2：对比
        chartShowDate: '-1', // '-1'：总体趋势，'xxxx,xxxx'：其他日期或时间区间

        dateInfo: DEFAULT_DATE,
      },

      analysisDataShowInfo: {
        isLinkAttr: false,
        date: [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')],
        groupPropertyType: -1,
        groupEventAndProp: {
          eventName: '',
          propertyName: '',
        },
      },

      formBookmark: {
        id: '',
        bookmarkName: '',
        remark: '',
      },
      formComponent: {
        id: '',
        name: '',
        boardId: '',
      },
      boardInfo: {},

      analysisData: null,

      isDoReset: false,
      resetData: {
        formValue: {
          id: undefined,

          retentionEventDTOS: [
            {
              showLabel: '',
              firstEvent: {
                eventName: '',
                eventChineseName: '',
                relationDTO: {
                  column: '',
                  chineseName: '',
                },
                connectors: 'and',
                conditionModels: [],
                groupBy: '',
              },
              followEvent: {
                eventName: '',
                eventChineseName: '',
                relationDTO: {
                  column: '',
                  chineseName: '',
                },
                connectors: 'and',
                conditionModels: [],
              },
            },
          ],

          globalFilters: {
            globalFilterList: [
              {
                globalFilterIndex: 1,
                globalFilterName: '全体用户',
                conditionModels: [],
                connectors: 'and',
              },
            ],
          },

          timeUnit: 'day',
          isCalcToday: 0,
          isRetention: 1,
          followStartDay: 2,
          followEndDay: 7,
          chartShowType: 1, // 1： 趋势，2：对比
          chartShowDate: '-1', // '-1'：总体趋势，'xxxx,xxxx'：其他日期或时间区间

          dateInfo: DEFAULT_DATE,
        },

        analysisDataShowInfo: {
          isLinkAttr: false,
          date: [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().subtract(1, 'day').format('YYYY-MM-DD')],
          groupPropertyType: -1,
          groupEventAndProp: {
            eventName: '',
            propertyName: '',
          },
        },
      },
    };
  },

  computed: {
    headTitle() {
      return this.formComponent.name || this.formBookmark.bookmarkName || '留存分析';
    },
    groupEventPropPlaceholder() {
      return this.analysisDataShowInfo.groupPropertyType === 1
        ? '请选择用于分组的事件属性'
        : '请选择用于分组的用户属性';
    },
    allFirstEvent() {
      const options = this.formValue.retentionEventDTOS
        .filter(item => item.firstEvent.eventName)
        .map(item => ({ eventName: item.firstEvent.eventName }));
      return options;
    },
    chartShowDateOptions() {
      let options = [];

      // 趋势
      if (this.formValue.chartShowType === 1) {
        options = [{ label: '总体趋势', value: '-1' }];
        if (!this.analysisData || !this.analysisData.length) {
          return options;
        }
        const { dateList } = this.analysisData[0];
        options = options.concat(dateList.map(item => ({ label: this.getEventNameText(item), value: item })));
        return options;
      }

      // 对比
      if (!this.analysisData || !this.analysisData.length) {
        return options;
      }

      const region = this.getRegion();
      for (let i = 0; i < region.length; i++) {
        options.push({
          label: this.getRegionItemText(region[i]),
          value: `${i}`,
        });
      }
      return options;
    },
    columnNameAndJavaTypeMap() {
      return this.formOption.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDataType;
        return total;
      }, {});
    },
  },

  watch: {
    $route() {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('routerReload'));
      }, 100);
    },
  },

  async created() {
    this.initUrlParams();
    this.initData();
  },

  beforeDestroy() {
    if (this.polling) {
      this.polling.stop();
    }
  },

  methods: {
    initUrlParams() {
      if (this.$route.query.bookmarkId) {
        this.formBookmark.id = this.$route.query.bookmarkId;
      }
      if (this.$route.query.compId) {
        this.formComponent.id = this.$route.query.compId;
      }
      if (this.$route.query.boardId) {
        this.formComponent.boardId = this.$route.query.boardId;
      }
    },

    async initData() {
      try {
        this.loading.initLoading = true;
        try {
          await this.getFormOption();
        } catch (e) {
          this.$message.warning((e && e.message) || '系统异常，请稍后重试');
        }

        if (this.formBookmark.id) {
          await this.fetchBookmarkDetail();
          this.handleGetData();
        }
        if (this.formComponent.id) {
          await this.fetchComponentInfo();
          this.handleGetData();
        }
        if (this.formComponent.boardId) {
          await this.fetchBoardInfo();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.initLoading = false;
        // 判断是否出现新手指引
        // setTimeout(() => {
        //   this.checkGuide();
        // }, 20);
      }
    },

    async getFormOption() {
      await new Promise(resolve => {
        const allFinished = [0, 0, 0];
        this.loading.fetchFormOption = true;

        const loadingStatus = () => Math.min(...allFinished) === 0;

        getEventList({ params: { getType: 'all' } })
          .then(res => {
            this.formOption.eventList = res || [];
          })
          .finally(() => {
            allFinished[0] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getAllProperty({ params: { hasData: 1, isVisible: 1 } })
          .then(res => {
            this.formOption.conditionPropertyOptions = (res.list || []).map(item => ({
              propertyType: item.propertyType,
              propertyName: item.name,
              propertyDesc: item.chineseName,
              propertyDataType: item.javaType,
              name: item.name,
              propertyValueTipVOList: item.propertyValueTipVOList,
            }));
          })
          .finally(() => {
            allFinished[1] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });

        getConditionOperator()
          .then(res => {
            this.formOption.conditionOperatorOptions = res;
          })
          .finally(() => {
            allFinished[2] = 1;
            const loading = loadingStatus();
            this.loading.fetchFormOption = loading;
            if (!loading) {
              resolve();
            }
          });
      });

      await this.getAllEventProperty();
    },

    async getAllEventProperty() {
      const res = (await getAllEventProperty({})) || [];
      this.formOption.allEventProperty = res.map(item => ({
        eventName: item.eventName,
        eventShowName: item.eventShowName,
        propertyList: (item.propertyList || []).map(i => ({
          propertyName: i.name,
          propertyDesc: i.chineseName,
          propertyType: i.propertyType,
          propertyDataType: i.javaType,
        })),
      }));
    },

    handleOpenSave() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.showBookmarkModal = true;
    },

    async fetchBookmarkDetail() {
      const { id } = this.formBookmark;

      if (!id) {
        throw new Error(`bookmark id is required, which id is ${id}}`);
      }

      this.loading.fetchBookmark = true;

      try {
        const res = await getBookmarkDetail({ params: { id } });

        this.formBookmark.bookmarkName = res.bookmarkName;
        this.formBookmark.remark = res.remark;

        this.recoverConfig(res);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading.fetchBookmark = false;
      }
    },

    async fetchComponentInfo() {
      try {
        const { id } = this.formComponent;
        const retData = await getComponentList({ params: { id } });
        if (!retData || !retData.length) return;

        Object.assign(this.formComponent, retData[0]);
        const params = this.formComponent.analysisModelDetailVO || {};

        this.recoverConfig(params);

        this.backup$Data();
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBoardInfo() {
      try {
        const res = await getBoardDetail({ params: { boardId: this.formComponent.boardId } });
        this.boardInfo = res;
        if (!this.boardInfo.componentList) {
          this.boardInfo.componentList = [];
        }
        if (!this.boardInfo.globalConditionConfigVO) {
          this.boardInfo.globalConditionConfigVO = {};
        }
      } catch (e) {
        console.error(e);
      }
    },

    // 把数据还原成页面的配置
    recoverConfig(res) {
      const pickRes = pick(res, [
        'id',
        'dateInfo',
        'globalFilters',
        'timeUnit',
        'retentionEventDTOS',
        'isCalcToday',
        'isRetention',
        'followStartDay',
        'followEndDay',
        'chartShowType',
        'chartShowDate',
      ]);
      const formData = this.dataToForm(pickRes);
      this.formValue = formData;
    },

    validConfig() {
      const { formValue } = this;
      let validRet = true;
      const v1 = formValue.retentionEventDTOS.length;
      if (!v1) {
        this.$message.warning('请设置行为事件');
        validRet = false;
        return validRet;
      }
      let v2 = true;
      let v3 = true;
      if (this.analysisDataShowInfo.isLinkAttr) {
        formValue.retentionEventDTOS.forEach(item => {
          if (!item.firstEvent.relationDTO.column || !item.followEvent.relationDTO.column) {
            v2 = false;
          }
          if (
            this.columnNameAndJavaTypeMap[item.firstEvent.relationDTO.column] !==
            this.columnNameAndJavaTypeMap[item.followEvent.relationDTO.column]
          ) {
            v3 = false;
          }
        });
      }
      if (!v2) {
        this.$message.warning('请设置关联属性');
        validRet = false;
        return validRet;
      }
      if (!v3) {
        this.$message.warning('关联属性值类型不一致，请修改');
        validRet = false;
        return validRet;
      }
      let v4 = true;
      formValue.retentionEventDTOS.forEach(item => {
        if (!item.firstEvent.eventName || !item.followEvent.eventName) {
          v4 = false;
        }
      });
      if (!v4) {
        this.$message.warning('请完善行为事件');
        validRet = false;
        return validRet;
      }
      return validRet;
    },

    async fetchAnalysisData(formValue) {
      this.analysisData = null;
      this.loading.fetchData = true;

      let retData;

      try {
        const uuid = await getRetentionPollingId({ data: formValue });
        this.polling = new PollingAction({
          delay: 2000,
          handler: async () => {
            retData = await getRetentionPollingData({ params: { uuid } });
            if (!retData) return true;
            this.loading.fetchData = false;
            this.analysisData = retData;
            return false;
          },
        });

        await this.polling.start();

        if (!retData) {
          throw new Error(`retData is ${retData}`);
        }
      } catch (e) {
        console.error(e);
        this.$message.error(e.message);
        this.loading.fetchData = false;
      }
    },

    // 接口数据转化为表单数据
    dataToForm(data) {
      if (!data) return {};
      const currData = lodash.cloneDeep(data);
      const { dateInfo, retentionEventDTOS, globalFilters, chartShowDate } = currData;

      let isLinkAttr = false;
      let groupPropertyType = -1;
      let groupPropertyEventName = '';
      let groupPropertyPropertyName = '';
      retentionEventDTOS.forEach((item, index) => {
        const { firstEvent, followEvent } = item;
        if (firstEvent.relationDTO.column || followEvent.relationDTO.column) {
          isLinkAttr = true;
        }
        if (firstEvent.groupBy) {
          groupPropertyEventName = index;
          groupPropertyPropertyName = firstEvent.groupBy;
          const ep = this.formOption.allEventProperty.find(item1 => item1.eventName === firstEvent.eventName) || {
            propertyList: [],
          };
          const p = ep.propertyList.find(item2 => item2.propertyName === firstEvent.groupBy) || { propertyType: -1 };
          groupPropertyType = p.propertyType;
        }
      });

      this.analysisDataShowInfo.groupPropertyType = groupPropertyType;
      this.analysisDataShowInfo.groupEventAndProp.eventName = groupPropertyEventName;
      this.analysisDataShowInfo.groupEventAndProp.propertyName = groupPropertyPropertyName;

      this.analysisDataShowInfo.isLinkAttr = isLinkAttr;
      this.analysisDataShowInfo.date = [
        dayjs(dateInfo.startTime).format('YYYY-MM-DD'),
        dayjs(dateInfo.endTime).format('YYYY-MM-DD'),
      ];

      return {
        ...currData,
        retentionEventDTOS: retentionEventDTOS || [
          {
            showLabel: '',
            firstEvent: {
              eventName: '',
              eventChineseName: '',
              relationDTO: {
                column: '',
                chineseName: '',
              },
              connectors: 'and',
              conditionModels: [],
              groupBy: '',
            },
            followEvent: {
              eventName: '',
              eventChineseName: '',
              relationDTO: {
                column: '',
                chineseName: '',
              },
              connectors: 'and',
              conditionModels: [],
            },
          },
        ],
        globalFilters: globalFilters || {
          globalFilterList: [
            {
              globalFilterIndex: 1,
              globalFilterName: '全体用户',
              conditionModels: [],
              connectors: 'and',
            },
          ],
        },
        chartShowDate: `${chartShowDate}`,
      };
    },

    // 表单数据转化接口数据
    getFormData() {
      const formValue = lodash.cloneDeep(this.formValue);

      const { retentionEventDTOS } = formValue;
      const { eventName, propertyName } = this.analysisDataShowInfo.groupEventAndProp;
      retentionEventDTOS.forEach((item, index) => {
        const { firstEvent } = item;
        firstEvent.groupBy = '';
        if (index === eventName) {
          firstEvent.groupBy = propertyName;
        }
      });

      return {
        ...formValue,
        dateInfo: {
          timeType: 'static',
          timeDimension: formValue.timeUnit,
          startTime: dayjs(this.analysisDataShowInfo.date[0]).format('YYYYMMDD'),
          endTime: dayjs(this.analysisDataShowInfo.date[1]).format('YYYYMMDD'),
        },
      };
    },

    handleQueryClick() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.formValue.chartShowType = 1;
      this.formValue.chartShowDate = '-1';
      const formValue = this.getFormData();
      this.fetchAnalysisData(formValue);
    },

    handleGetData() {
      const formValue = this.getFormData();
      this.fetchAnalysisData(formValue);
    },

    async handleSaveBookmark(form) {
      try {
        const { id, bookmarkName, remark } = form;
        const params = {
          ...{
            id,
            bookmarkName,
            remark,
          },
          analysisType: 'retention',
          attributionAnalysisReq: this.getFormData(),
        };

        this.loading.submitting = true;
        const retData = await saveAsBookmark({ data: params });

        this.$message.success('保存成功');

        this.showBookmarkModal = false;

        this.$router.replace({
          name: 'RetentionAnalysis',
          query: {
            bookmarkId: params.id || retData,
          },
        });
      } catch (e) {
        //
      } finally {
        this.loading.submitting = false;
      }
    },

    async handleSaveComponent(type, form) {
      const analysisModelReq = this.getFormData();

      const params = {
        analysisType: 'retention',
        analysisModelReq: JSON.stringify(analysisModelReq),
      };

      const propArr = ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext', 'lineCount'];

      const tmpObj = pick(form, propArr);
      Object.assign(params, tmpObj);

      let retData;
      try {
        this.loading.submitting = true;

        if (type === 'new') {
          await createComponent({ data: params });
        } else {
          await modifyComponent({ data: params });
        }

        this.$message.success('保存成功');
        this.showBookmarkModal = false;

        setTimeout(() => {
          this.$router.replace({
            name: 'OverviewHome',
            query: {
              boardId: params.boardId,
            },
          });
        }, 100);
      } finally {
        this.loading.submitting = false;
      }
    },

    handleAddGlobalFilter() {
      if (this.formValue.globalFilters.globalFilterList.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      const globalFilterIndex = this.formValue.globalFilters.globalFilterList.length + 1;
      this.formValue.globalFilters.globalFilterList.push({
        globalFilterIndex,
        globalFilterName: '全体用户',
        conditionModels: [],
        connectors: 'and',
      });
    },
    handleDeleteConditionModels(index) {
      this.formValue.globalFilters.globalFilterList.splice(index, 1);
      this.formValue.globalFilters.globalFilterList.forEach((globalFilter, idx) => {
        globalFilter.globalFilterIndex = idx + 1;
      });
    },

    onPropertyTypeChange() {
      this.analysisDataShowInfo.groupEventAndProp.eventName = '';
      this.analysisDataShowInfo.groupEventAndProp.propertyName = '';
    },

    handleChangeTimeUnit() {
      this.formValue.followStartDay = this.formValue.timeUnit !== 'day' ? null : 2;
      this.formValue.followEndDay = this.formValue.timeUnit !== 'day' ? null : 7;
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    handleChangeDate() {
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    handleChangeFollowStartDay() {
      if (
        this.formValue.followStartDay &&
        this.formValue.followEndDay &&
        this.formValue.followEndDay <= this.formValue.followStartDay
      ) {
        this.formValue.followEndDay = this.formValue.followStartDay + 5;
      }
      if (this.analysisData && this.formValue.followStartDay && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },
    handleChangeFollowEndDay() {
      if (this.analysisData && this.formValue.followEndDay && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },
    handleChangeIsRetention() {
      if (this.analysisData && !this.loading.fetchData && !this.isDoReset) {
        this.handleQueryClick();
      }
    },

    handleChangeChartShowType() {
      const options = this.chartShowDateOptions;
      this.formValue.chartShowDate = options && options.length ? options[0].value : '';
    },

    getRegion() {
      const { dataList } = this.analysisData[0];
      const { isCalcToday, followStartDay, followEndDay, timeUnit } = this.formValue;
      const region = [];

      if (timeUnit === 'day') {
        if (isCalcToday) {
          region.push(1);
        }
        for (let i = followStartDay; i <= followEndDay; i++) {
          region.push(i);
        }
      }
      if (timeUnit === 'week' || timeUnit === 'month') {
        const totalNum = dataList[0].summary.length - 2;
        let followStart = isCalcToday ? 1 : 2;
        for (let i = 0; i < totalNum; i++) {
          region.push(followStart);
          followStart += 1;
        }
      }
      return region;
    },
    getRegionItemText(regionItem) {
      return regionItem === 1
        ? `当${DEFAULT_TIME_UNIT_ENUM[this.formValue.timeUnit]}`
        : `第${regionItem}${DEFAULT_TIME_UNIT_ENUM[this.formValue.timeUnit]}`;
    },
    getEventNameText(eventName) {
      const { timeUnit } = this.formValue;
      if (timeUnit === 'day') {
        return dayjs(eventName).format('MM-DD');
      }
      if (timeUnit === 'week') {
        const arr = eventName.split('-');
        return `${dayjs(arr[0]).format('MM-DD')}~${dayjs(arr[1]).format('MM-DD')}`;
      }
      const arr = eventName.split('-');
      return dayjs(arr[0]).format('YYYY-MM');
    },
    backup$Data() {
      this.$set(this.resetData, 'formValue', lodash.cloneDeep(this.formValue));
      this.$set(this.resetData, 'analysisDataShowInfo', lodash.cloneDeep(this.analysisDataShowInfo));
    },

    handleReset() {
      this.isDoReset = true;
      const formValue = lodash.cloneDeep(this.resetData.formValue);
      const analysisDataShowInfo = lodash.cloneDeep(this.resetData.analysisDataShowInfo);
      this.$set(this.$data, 'formValue', formValue);
      this.$set(this.$data, 'analysisDataShowInfo', analysisDataShowInfo);
      this.$nextTick(() => {
        this.isDoReset = false;
      });
    },

    handleBack() {
      this.$router.replace({
        name: 'OverviewHome',
        query: {
          boardId: this.formComponent.boardId,
        },
      });
    },

    async checkGuide() {
      const me = this;
      const code = 'CustomZone.GuiyinAnalysis.FirstVisit';
      this.guideDriver = this.initGuideDriver({
        onReset() {
          me.setVisitedStatus(code, 1);
        },
      });
      this.initGuideSteps();
      const isVisited = await this.getVisitedStatus(code);
      if (!isVisited) {
        this.guideDriver.start();
      }
    },

    getGroupOptionLabelFormat({ index, eventProperty }) {
      const event = this.formValue.retentionEventDTOS[index];
      return event ? `${event.showLabel}起始事件` : eventProperty.eventShowName;
    },

    getGroupOptionValueFormat({ index, eventProperty }) {
      return index;
    },

    handleGroupEventAndPropChange(val) {
      this.formValue.retentionEventDTOS.forEach(item => {
        item.firstEvent.groupBy = '';
      });
      if (val && val.eventName >= 0 && val.propertyName) {
        this.formValue.retentionEventDTOS[val.eventName].firstEvent.groupBy = val.propertyName;
      }
    },

    initGuideSteps() {
      const me = this;
      const { guideDriver } = this;
      guideDriver.defineSteps([
        {
          element: '.new-guide-step-1',
          popover: {
            className: 'first-step-popover-class',
            closeBtnText: '跳过(1/5)',
            title: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
            description: '这里可选择一个目标转化事件，一般是与收益相关的事件（比如广告或坑位带来的销售额）',
          },
        },
        {
          element: '.new-guide-step-2',
          popover: {
            closeBtnText: '跳过(2/5)',
            title: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
            description: '这里可选择对目标事件有贡献的事件（比如广告渠道或坑位）',
          },
        },
        {
          element: '.new-guide-step-3',
          popover: {
            closeBtnText: '跳过(3/5)',
            title: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
            description: '这里可选择不同的归因类型模型，来评估不同渠道对目标事件的贡献率',
          },
        },
        {
          element: '.new-guide-step-4',
          popover: {
            closeBtnText: '跳过(4/5)',
            title: '这里可限定待归因事件到目标转化事件之间的最长时间',
            description: '这里可限定待归因事件到目标转化事件之间的最长时间',
          },
        },
        {
          element: '.new-guide-step-5',
          popover: {
            closeBtnText: '跳过(5/5)',
            title: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
            description: '这里可对全部事件添加筛选项，选择参与人群，并为分析结果选择维度来分组',
          },
          onNext() {
            me.highlightTriggerElement();
          },
        },
      ]);
    },

    handleStartGuide() {
      this.guideDriver.start();
    },

    exportData() {
      // const fileName = `腾讯有数-留存分析结果-${dayjs().format('YYYY-MM-DD')}.xlsx`;

      let tmpGroupBy = [];
      if (this.formValue.groupBy) {
        tmpGroupBy = this.formValue.groupBy.split(',');
        tmpGroupBy = tmpGroupBy.map(item => {
          const findProperty = this.conditionPropertyOptions.find(i => i.propertyName === item);
          return {
            val: item,
            label: findProperty ? findProperty.propertyDesc : '未知属性',
          };
        });
      }

      const fileName = '分析结果.xlsx';
      const data = [];
      const title = ['事件/日期', '全局筛选'];

      let showGroup = false;
      if (this.analysisData) {
        this.analysisData.forEach(item => {
          item.dataList.forEach(subItem => {
            if (subItem.groupBy) {
              showGroup = true;
            }
          });
        });
      }
      if (showGroup) {
        title.push('分组');
      }
      title.push('起始人数');
      const region = this.getRegion();
      for (let i = 0; i < region.length; i++) {
        title.push(this.getRegionItemText(region[i]));
      }
      data.push(title);

      this.analysisData.forEach((analysisDataItem, analysisDataItemIndex) => {
        analysisDataItem.dataList.forEach((item, itemIndex) => {
          const row = [
            `${item.eventChineseName || item.eventName} ${item.showLabel}${itemIndex}`,
            item.globalFilerName,
          ];
          if (showGroup) {
            row.push(item.groupBy);
          }
          row.push(item.summary[1]);

          if (region.length) {
            const values = item.summary.slice(2, item.summary.length);
            for (let i = 0; i < region.length; i++) {
              row.push(values[i] ? `${values[i][0]}(${numeral(values[i][1]).format('0.00%')})` : '');
            }
          }

          data.push(row);

          item.details.forEach((detail, subIndex) => {
            const childRow = [this.getEventNameText(detail[0]), item.globalFilerName];
            if (showGroup) {
              childRow.push(item.groupBy);
            }
            childRow.push(detail[1]);

            if (region.length) {
              const detailValues = detail.slice(2, detail.length);
              for (let i = 0; i < region.length; i++) {
                childRow.push(
                  detailValues[i] ? `${detailValues[i][0]}(${numeral(detailValues[i][1]).format('0.00%')})` : '',
                );
              }
            }
            data.push(childRow);
          });
        });
      });

      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '留存分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style scoped lang="less">
@import 'retention-analysis.less';
</style>
